import { Trans } from '@lingui/macro';
import { List, ListSubHeader } from '@pocketlaw/tetris';
import { Feedback } from './Feedback';
import { usePlai } from '../PlaiProvider';
export function ReviewFeedback() {
    const { review } = usePlai();
    const { feedbacks = [] } = review || {};
    if (feedbacks.length < 1) {
        return null;
    }
    return (<List $density="large">
      <ListSubHeader>
        <Trans comment="Plai Drawer - Issues section - title">Issues</Trans>
      </ListSubHeader>
      {[...feedbacks].map(feedback => (<Feedback key={feedback.feedback.id} {...feedback}/>))}
    </List>);
}
